import { observer } from "mobx-react";
import React, { useMemo, useState } from "react";
import ReactApexChart from "react-apexcharts";

const RadialBarChart = observer(({ seriesData }) => {
  const labels = seriesData.map((stat) => stat.title);
  const series = seriesData.map((stat) => stat.total);

  const chartOptions = useMemo(() => {
    return {
      chart: {
        height: 350,
        type: "radialBar",
      },
      plotOptions: {
        radialBar: {
          dataLabels: {
            name: {
              fontSize: "22px",
            },
            value: {
              fontSize: "16px",
            },
            total: {
              show: true,
              label: "Total",
              formatter: function (w) {
                return series.reduce((a, b) => a + b, 0);
              },
            },
          },
        },
      },
      labels: labels,
    };
  });
  return (
    <div>
      <ReactApexChart
        options={chartOptions}
        series={series}
        type="radialBar"
        height={225}
      />
    </div>
  );
});

export default React.memo(RadialBarChart);
